<template>
  <div
    :class="
      twMerge(
        'flex flex-row items-center justify-center gap-2 md:gap-4',
        ($attrs.class as string) || '',
      )
    "
    data-testid="services-group-buttons"
  >
    <ButtonContactUs
      text="Contact Us"
      :services="initialFields"
      class="flex-shrink-0 text-sm font-semibold leading-5 md:!w-fit"
    />

    <slot />

    <template v-if="file">
      <CommonButton
        v-if="'url' in file"
        data-testid="redirect-button"
        class="mx-0 !w-fit text-sm font-semibold leading-5"
        variant="secondary"
        @click="$router.push(file.url)"
      >
        {{ downloadText }}
      </CommonButton>

      <ButtonDownload
        v-else
        data-testid="download-button"
        class="mx-0 !w-fit text-sm font-semibold leading-5"
        variant="secondary"
        :text="downloadText"
        :download-file="file"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

import CommonButton from '~/components/common/Button.vue'
import ButtonDownload from '~/components/shared/common/ButtonDownload.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import type { TFileDownloadInfo } from '~/src/types/download'

withDefaults(
  defineProps<{
    downloadText?: string
    initialFields: string[]
    file?: TFileDownloadInfo
  }>(),
  {
    downloadText: 'Methodology',
  },
)

const { $router } = useNuxtApp()
</script>
